import React, { useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import "./handoverNote.css";

const HandoverNote = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const noteRef = useRef();
  const { asset } = location.state || {};

  if (!asset) {
    return (
      <div className="handover-container">
        <h2>No Asset Data Available</h2>
        <button onClick={() => navigate(-1)} className="btn btn-primary">
          Go Back
        </button>
      </div>
    );
  }

  const currentDate = new Date().toLocaleDateString("en-US", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });

  const handleDownloadPDF = async () => {
    const element = noteRef.current;
    const canvas = await html2canvas(element, {
      scale: 2,
      backgroundColor: "#ffffff",
    });

    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF({
      orientation: "portrait",
      unit: "mm",
      format: "a4",
    });

    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = pdf.internal.pageSize.getHeight();
    const imgWidth = pdfWidth - 20;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;

    pdf.addImage(imgData, "PNG", 10, 10, imgWidth, imgHeight);
    pdf.save(`handover_note_${asset.trackingId}.pdf`);
  };

  return (
    <div className="handover-container">
      {/*<div className="handover-header">
        <h1>ASSET HANDOVER NOTE</h1>
        <div className="button-group">
          <button onClick={handleDownloadPDF} className="btn btn-download">
            <i className="fas fa-download"></i> Download PDF
          </button>
          <button onClick={() => navigate(-1)} className="btn btn-back">
            <i className="fas fa-arrow-left"></i> Back
          </button>
        </div>
      </div>*/}

      
<div className="elegant-header">
  <h1 className="handover-title">ASSET HANDOVER NOTE</h1>

  <div className="header-actions">
    <button onClick={handleDownloadPDF} className="header-btn download-btn">
      <i className="fas fa-download"></i> Download PDF
    </button>
    <button onClick={() => navigate(-1)} className="header-btn back-btn">
      <i className="fas fa-arrow-left"></i> Back
    </button>
  </div>
</div>


      <div ref={noteRef} className="handover-note-print">
        <div className="note-header improved-header">
          <div className="logo-title-wrapper">
            {
              <img
                src={process.env.PUBLIC_URL + "/vellalogo.jpg"}
                alt="Vella Logo"
                className="handover-logo improved-logo"
              />
            }
            <div className="note-header-text improved-title">
              <h2>ASSET HANDOVER NOTE</h2>
            </div>
          </div>
        </div>

        <table className="handover-table">
          <tbody>
            <tr>
              <td className="label-cell">Registered Name</td>
              <td className="value-cell">{asset.name || ""}</td>
              <td className="label-cell">Company</td>
              <td className="value-cell">{asset.company || ""}</td>
            </tr>
            <tr>
              <td className="label-cell">Department</td>
              <td className="value-cell">{asset.department || ""}</td>
              <td className="label-cell">Category</td>
              <td className="value-cell">{asset.category || ""}</td>
            </tr>
            <tr>
              <td className="label-cell">Type</td>
              <td className="value-cell">{asset.type || ""}</td>
              <td className="label-cell">Asset Name</td>
              <td className="value-cell">{asset.assetName || ""}</td>
            </tr>
            <tr>
              <td className="label-cell">EPF No & Recipient Name</td>
              <td className="value-cell">{asset.assetUserName || ""}</td>
              <td className="label-cell">Model</td>
              <td className="value-cell">{asset.assetModel || ""}</td>
            </tr>
            <tr>
              {/*} <td className="label-cell">Register Date</td>
              <td className="value-cell">{asset.assetUpdateDate || ""}</td>*/}
              <td className="label-cell">
                {asset.
assetTransferDate ? "Transfer Date" : "Register Date"}
              </td>

              <td
                className={`value-cell ${asset.
assetTransferDate ? "transfer-date" : ""}`}
              >
                {asset.assetTransferDate
                  ? asset.assetTransferDate
                  : asset.assetUpdateDate || ""}
              </td>
              <td className="label-cell">Serial Number</td>
              <td className="value-cell">{asset.serialNumber || ""}</td>
            </tr>
            <tr>
              <td className="label-cell">Tracking ID</td>
              <td className="value-cell">{asset.trackingId || ""}</td>
              <td className="label-cell">Price (Rs)</td>
              <td className="value-cell">{asset.assetprice || ""}</td>
            </tr>
            <tr>
              <td className="label-cell">Special Note</td>
              <td className="value-cell" colSpan="3">
                {asset.specialNote || ""}
              </td>
            </tr>
          </tbody>
        </table>

        <div className="acknowledgment-section">
          <h3>Acknowledgment & Declaration by Recipient</h3>
          <div className="acknowledgment-content">
            <p>
              <strong>
                I acknowledge receipt of the listed assets, which are the
                property of Vella Group of Companies and for official use only.
              </strong>
            </p>
            <ul>
              <li>
                I will not use them for personal gain or transfer them to anyone
                under any circumstances.
              </li>
              <li>
                I commit to taking care of these assets and understand that I am
                responsible for any loss, damage, or misuse, with costs debited
                to my account.
              </li>
            </ul>
          </div>
        </div>

        <div className="signature-section">
          <div className="signature-box">
            <p>Asset Owner</p>
            <div className="signature-line"></div>
          </div>
          <div className="signature-box">
            <p>Signature of Receipt</p>
            <div className="signature-line"></div>
          </div>
          <div className="signature-box">
            <p>Authorized By</p>
            <div className="signature-line"></div>
          </div>
        </div>

      {/* Approval/metadata table as page footer 
        <div className="approval-table-section">
          <table className="approval-table">
            <tbody>
              <tr>
                <td className="label">Prepared/reviewed by:</td>
                <td className="value">Compliance Manager</td>
                <td className="label">Approved by:</td>
                <td className="value">Board of Directors</td>
              </tr>
              <tr>
                <td className="label">Doc No:</td>
                <td className="value">Vella/Compliance/CL/03</td>
                <td className="label">Date Issued:</td>
                <td className="value">10.10.2024</td>
              </tr>
              <tr>
                <td className="label">Revision No./ Date:</td>
                <td className="value">00/0000</td>
                <td className="label">Page No:</td>
                <td className="value"><span className="page-number">1 | <span className="page-text">P a g e</span></span></td>
              </tr>
            </tbody>
          </table>
        </div>*/}
      </div>
    </div>
  );
};

export default HandoverNote;
